module.exports = __webpack_public_path__ + "img/nav-logo-gp.31a4523f.svg";